import { render, staticRenderFns } from "./WordsMarkPoc.vue?vue&type=template&id=857076cc&"
import script from "./WordsMarkPoc.vue?vue&type=script&lang=js&"
export * from "./WordsMarkPoc.vue?vue&type=script&lang=js&"
import style0 from "./WordsMarkPoc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports